























import Vue from 'vue';

export interface DropdownOption {
  value: string;
  label: string;
  key: string;
  disabled: boolean;
}

export default Vue.extend({
  name: 'Dropdown',
  props: {
    value: {
      type: String,
      default: '',
    },
    category: {
      type: String,
      default: 'Category',
    },
    counter: {
      type: Number,
      default: 0,
    },
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isActive: Boolean,
  },
  methods: {
    onSelectChange(event: Event) {
      const el = event.target as HTMLSelectElement;
      this.$emit('change', el.value);
    },
  },
});
